module.exports = __webpack_public_path__ + "static/img/discount.7112f55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innerMessage/discount.svg
// module id = BDRL
// module chunks = 0